var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',_vm._g(_vm._b({class:_vm.buttonClasses,attrs:{"type":"button"}},'button',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"flex items-center"},[(_vm.loading)?_c('div',{staticClass:"loader mr-2"}):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }